import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";

const ContactUsSection = () => {
    return (
        <div className="flex flex-wrap justify-content-evenly align-items-center px-4 md:px-8 py-8 gap-6" style={{
            width: "100%",
            minHeight: "100vh",
            backgroundImage: "url('/ApplicationsImage.png')",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
        }}
        >
            <div className="flex flex-column gap-6">
                <p className="m-0 text-xl" style={{ color: "#BEC2D0", letterSpacing: "4px" }} >CONTACT US</p>
                <div>
                    <p className="m-0" style={{ color: "#2D3967", lineHeight: "3.25rem", fontSize: "3.75rem", fontWeight: 700 }} >
                        A New Era in <br /> Physical Therapy
                    </p>
                </div>
                <p className="m-0 text-xl xl:w-30rem" style={{ color: "#727A99", textWrap:"wrap" }} >
                    Exercise has never been this easy. Simplify home
                    exercise programs with Mobithera’s smart platform.
                </p>
                <div className="mb-4 md:mb-0 md:mt-8">
                    <p className="m-0" style={{ color: "#2D3967", fontSize: "1.75rem", fontWeight: 700 }} >Effortless Planning,</p>
                    <p className="m-0" style={{ color: "#E3506B", fontSize: "1.75rem", fontWeight: 700 }} >Effective Outcomes.</p>
                </div>
            </div>
            <div className="flex flex-column gap-4 w-30rem flex-grow-1 xl:flex-grow-0">
                <div className="flex flex-column gap-1">
                    <label htmlFor="fullname" className="text-base font-bold" style={{ color: "#727A99" }}>Full Name <span style={{ color: "#E3506B"}}>*</span></label>
                    <InputText id="fullname" className="" placeholder="Enter the Organization Name" style={{ border: "1px solid #9EA4B9", borderRadius: "10px" }} />
                </div>
                <div className="flex flex-column gap-1">
                    <label htmlFor="jobtitle" className="text-base font-bold" style={{ color: "#727A99" }}>Job Title <span style={{ color: "#E3506B"}}>*</span></label>
                    <InputText id="jobtitle" className="" placeholder="example@mail.com" style={{ border: "1px solid #9EA4B9", borderRadius: "10px" }} />
                </div>
                <div className="flex flex-column gap-1">
                    <label htmlFor="workmail" className="text-base font-bold" style={{ color: "#727A99" }}>Work Mail <span style={{ color: "#E3506B"}}>*</span></label>
                    <InputText id="workmail" className="" placeholder="Preffered Mobile" style={{ border: "1px solid #9EA4B9", borderRadius: "10px" }} />
                </div>
                <div className="flex flex-column gap-1">
                    <label htmlFor="help" className="text-base font-bold" style={{ color: "#727A99" }}>How can we help?</label>
                    <InputTextarea id="help" className="" placeholder="Tell us briefly what you're looking for—clinic use, patient experience, integration, etc." style={{ border: "1px solid #9EA4B9", borderRadius: "10px" }} />
                </div>
                <Button className="flex justify-content-center align-items-center gap-1"
                    style={{
                        color: "white",
                        backgroundColor: "#E3506B",
                        borderRadius: "10px",
                        height: "2.5rem",
                        fontWeight: "bold"
                    }}>
                        Submit
                        <img src="/Check.png" width={20} />
                </Button>
            </div>
        </div>
    )
}

export default ContactUsSection;